import Button from 'components/Button'
import CronEditor from 'components/CronEditor'
import { getDefaultColumns } from 'components/CronOrdersList/TableParts'
import HeaderControls from 'components/InfinityTable/HeaderControls'
import ListContainer from 'components/InfinityTable/ListContainer'
import { generateRedux } from 'components/InfinityTable/Redux'
import Sort from 'components/InfinityTable/Sort'
import lodash from 'lodash'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'

import Delete from './Delete'
export const redux = generateRedux({
  id: 'containers/CronOrdersList/',
  url: '/api/cronorder',
  initialState: {
    sortableColumns: ['id', 'name'],
  },
  sagas: [],
})

const HeaderRow = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`

const connectRedux = connect(
  createStructuredSelector({
    ...redux.structuredSelector,
    // additional selectors here
  }),
  {
    ...redux.actions,
  },
)

const CronOrdersList = (props) => {
  const {} = props

  useEffect(() => {
    props.applyFilter({ reset: true, onlyFts: false })
  }, [])

  // console.log('trigger pr deploy')
  const [localLoading, setLocalLoading] = useState(false)
  const headerControls = <HeaderControls controls={[]} />

  const mobileColumn = [
    {
      headerRenderer: (renderprops) => (
        <HeaderRow className="d-flex justify-content-between align-items-center">
          <Sort
            {...props}
            sorts={props.sort}
            sortKey="id"
            applyFilter={props.applyFilter}
            setSort={props.setSort}
            sortableColumns={props.sortableColumns}
            label="#"
          />
          {headerControls}
        </HeaderRow>
      ),
    },
  ]

  const columns = [
    {
      label: null,
      disableSort: true,
      dataKey: ['id', 'name'],
      isActionColumn: true,
      cellRenderer: (cellProps) => {
        const { cellData, isMobile } = cellProps
        return (
          <>
            <Button to={`/cronorder/${lodash.get(cellData, 'id')}`} info sm>
              <i className="fas fa-eye" />
            </Button>
            <CronEditor
              values={cellProps.rowData}
              spanClass="ml-2"
              setLoading={setLocalLoading}
              applyFilter={() =>
                props.applyFilter({ reset: true, onlyFts: false })
              }
              buttonElement={
                <Button
                  className="mr-2"
                  tooltip={i18n.t(
                    'cron_editor_order_update',
                    'Dauerauftrag bearbeiten',
                  )}
                  info
                  sm
                >
                  <i className="fas fa-pencil" />
                </Button>
              }
            />
            <Delete
              setLoading={setLocalLoading}
              applyFilter={props.applyFilter}
              id={cellData.id}
              name={cellData.name}
            />
          </>
        )
      },
    },
  ]

  const filter = [
    {
      name: 'name',
      label: i18n.t('name', 'name'),
      autoFocus: true,
      type: 'value',
      colWidth: 12,
    },
    {
      name: 'fulltext',
      label: i18n.t('search_cron_orders_list', 'Suche nach Id oder Name'),
      type: 'fulltext',
      exludeForDetail: true,
      showForFts: true,
      colWidth: 12,
    },
  ]

  const mobileCellHeaderItems = ({ rowData }) => [
    {
      width: '50px',
      label: lodash.get(rowData, 'id', '?'),
    },
    {
      flex: '1',
      label: lodash.get(rowData, 'name', ''),
    },
  ]

  const [defaultColumns] = useState(getDefaultColumns())

  return (
    <ListContainer
      {...props}
      columns={[...defaultColumns, ...columns]}
      isLoading={props.isLoading || localLoading}
      filter={filter}
      mobileColumn={mobileColumn}
      rowHeight={150}
      mobileRowHeight={320}
      mobileRowHeightCollapsed={35}
      title={i18n.t('cron_orders', 'Daueraufträge')}
      mobileCellHeaderItems={mobileCellHeaderItems}
    />
  )
}

export default connectRedux(CronOrdersList)
